import { render, staticRenderFns } from "./intelligentEvaluation.vue?vue&type=template&id=722bb0c7&scoped=true&"
import script from "./intelligentEvaluation.vue?vue&type=script&lang=js&"
export * from "./intelligentEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./intelligentEvaluation.vue?vue&type=style&index=0&id=722bb0c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722bb0c7",
  null
  
)

export default component.exports